import type * as ReactRouter from "react-router";
import { MonitoringPage } from "~/app/components/landing/monitoring-page";
import { getTranslationFn } from "~/app/i18n";

const t = getTranslationFn("en");

export const meta: ReactRouter.MetaFunction = () => [
  { title: t("Monitoring.metaTitle") },
  { name: "description", content: t("Monitoring.metaDescription") },
];

export default function MonitoringEN() {
  return <MonitoringPage locale="en" />;
}
